
import React, { useRef, useState } from 'react';
import './Destinations.css';

import saudiImg from '../assets/images/saudi.jpg';
import dubaiImg from '../assets/images/dubai.jpeg';
import turkeyImg from '../assets/images/turkey.jpeg';
import malaysiaImg from '../assets/images/malaysia.jpeg';
import madivesImg from '../assets/images/madives.jpeg';
import thailandImg from '../assets/images/thailand.jpg';
import singaporeImg from '../assets/images/singapore.jpeg';
import philippinesImg from '../assets/images/philippines.jpg';

const destinations = [
  {
    img: saudiImg,
    alt: 'Saudi Arabia',
    title: 'Saudi Arabia',
    type: 'Culture & Modern Vision',
    desc: 'Experience the perfect blend of rich heritage and ambitious future vision',
    highlights: ['NEOM City', 'Al-Ula', 'Red Sea Project', 'Diriyah Gate'],
    button: 'Explore Saudi Arabia',
  },
  {
    img: dubaiImg,
    alt: 'Dubai',
    title: 'Dubai, UAE',
    type: 'Luxury & Shopping',
    desc: 'Experience the perfect blend of modern luxury and Arabian culture',
    highlights: ['Burj Khalifa', 'Dubai Mall', 'Desert Safari', 'Palm Jumeirah'],
    button: 'Explore Dubai',
  },
  {
    img: turkeyImg,
    alt: 'Turkey',
    title: 'Turkey',
    type: 'History & Culture',
    desc: 'Where East meets West - discover ancient history and modern charm',
    highlights: ['Hagia Sophia', 'Cappadocia', 'Grand Bazaar', 'Turkish Riviera'],
    button: 'Explore Turkey',
  },
  {
    img: malaysiaImg,
    alt: 'Malaysia',
    title: 'Malaysia',
    type: 'Nature & Modern Cities',
    desc: 'A perfect mix of urban excitement and tropical paradise',
    highlights: ['Petronas Towers', 'Langkawi Islands', 'Penang Heritage', 'Batu Caves'],
    button: 'Explore Malaysia',
  },
  {
    img: madivesImg,
    alt: 'Maldives',
    title: 'Maldives',
    type: 'Luxury & Romance',
    desc: 'Paradise on Earth with crystal clear waters and luxury resorts',
    highlights: ['Overwater Villas', 'Coral Reefs', 'Water Sports', 'Sunset Cruises'],
    button: 'Explore Maldives',
  },
  {
    img: thailandImg,
    alt: 'Thailand',
    title: 'Thailand',
    type: 'Culture & Beaches',
    desc: 'From bustling cities to serene beaches and ancient temples',
    highlights: ['Bangkok Temples', 'Phuket Beaches', 'Phi Phi Islands', 'Chiang Mai'],
    button: 'Explore Thailand',
  },
  {
    img: singaporeImg,
    alt: 'Singapore',
    title: 'Singapore',
    type: 'Modern & Family Fun',
    desc: 'Ultra-modern city-state with endless entertainment options',
    highlights: ['Marina Bay Sands', 'Gardens by the Bay', 'Universal Studios', 'Sentosa Island'],
    button: 'Explore Singapore',
  },
  {
    img: philippinesImg,
    alt: 'Philippines',
    title: 'Philippines',
    type: 'Islands & Nature',
    desc: 'Discover paradise with over 7,000 tropical islands and vibrant culture',
    highlights: ['Boracay Beach', 'Palawan Islands', 'Chocolate Hills', 'Siargao Island'],
    button: 'Explore Philippines',
  },
];




const Destinations = () => {
  const carouselRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  // Scroll by card width
  const scroll = (dir) => {
    const cardWidth = 370 + 32; // Card width + gap
    if (carouselRef.current) {
      const newScroll = dir === 'left' ? carouselRef.current.scrollLeft - cardWidth : carouselRef.current.scrollLeft + cardWidth;
      carouselRef.current.scrollTo({ left: newScroll, behavior: 'smooth' });
    }
  };

  // Mouse drag-to-scroll handlers
  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - carouselRef.current.offsetLeft);
    setScrollLeft(carouselRef.current.scrollLeft);
  };
  const handleMouseLeave = () => setIsDragging(false);
  const handleMouseUp = () => setIsDragging(false);
  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - carouselRef.current.offsetLeft;
    const walk = (x - startX) * 1.2;
    carouselRef.current.scrollLeft = scrollLeft - walk;
  };

  return (
    <section id="destinations" className="destinations-section">
      <div className="destinations-header">
        <h2 className="destinations-title">Popular Destinations</h2>
        <p className="destinations-subheadline">Discover the world’s most exciting places, handpicked for you.</p>
      </div>
      <div className="destinations-carousel-wrapper">
        <button className="carousel-arrow left" onClick={() => scroll('left')} aria-label="Scroll left">
          <span>&lt;</span>
        </button>
        <div
          className="destinations-carousel"
          ref={carouselRef}
          onMouseDown={handleMouseDown}
          onMouseLeave={handleMouseLeave}
          onMouseUp={handleMouseUp}
          onMouseMove={handleMouseMove}
        >
          {destinations.map((dest, idx) => (
            <div className="destination-card" key={idx}>
              <div className="destination-image-wrapper">
                <img src={dest.img} alt={dest.alt} loading="lazy" className="destination-image" />
                <div className="destination-type-chip">{dest.type}</div>
              </div>
              <div className="destination-content">
                <h3>{dest.title}</h3>
                <p className="destination-desc">{dest.desc}</p>
                <ul className="destination-highlights">
                  {dest.highlights.map((h, i) => (
                    <li key={i}><span className="dot">•</span> {h}</li>
                  ))}
                </ul>
                <button className="destination-btn">{dest.button}</button>
              </div>
            </div>
          ))}
        </div>
        <button className="carousel-arrow right" onClick={() => scroll('right')} aria-label="Scroll right">
          <span>&gt;</span>
        </button>
      </div>
    </section>
  );
};

export default Destinations;
